import React, { useState } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sparkles, LayoutDashboard, Users, Boxes, CalendarDays, HeartHandshake, Flag, Dumbbell, MapPin, Globe, Settings, LogOut, Menu, LifeBuoy, BarChart3, Ticket, ShieldAlert } from "lucide-react";

const NAV = [
    { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
    { to: "/admin/analytics", label: "Analytics", icon: BarChart3 },
    { to: "/admin/members", label: "Members", icon: Users },
    { to: "/admin/groups", label: "Groups", icon: Boxes },
    { to: "/admin/outings", label: "Outings", icon: CalendarDays },
    { to: "/admin/venue-approvals", label: "Venue Approvals", icon: MapPin },
    { to: "/admin/mutual-interest", label: "Mutual Interest", icon: HeartHandshake },
    { to: "/admin/reports", label: "Reports", icon: Flag },
    { to: "/admin/safety-review", label: "Safety Review", icon: ShieldAlert },
    { to: "/admin/support-tickets", label: "Support Tickets", icon: LifeBuoy },
    { to: "/admin/activities", label: "Activities", icon: Dumbbell },
    { to: "/admin/venues", label: "Venues", icon: MapPin },
    { to: "/admin/markets", label: "Markets", icon: Globe },
    { to: "/admin/codes", label: "Access Codes", icon: Ticket },
    { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout() {
    const { logout } = useAuth();
    const [open, setOpen] = useState(false);
    return (
        <div className="admin-scope min-h-screen overflow-x-hidden text-zinc-900">
            <div className="flex">
                {open && <div className="fixed inset-0 z-30 bg-black/40 lg:hidden" onClick={() => setOpen(false)} data-testid="admin-nav-backdrop" />}
                <aside className={`fixed inset-y-0 left-0 z-40 w-60 border-r border-zinc-200 bg-white transition-transform lg:translate-x-0 ${open ? "translate-x-0" : "-translate-x-full"}`}>
                    <div className="flex items-center gap-2 border-b border-zinc-200 px-5 py-4">
                        <span className="grid h-8 w-8 place-items-center rounded bg-zinc-900"><Sparkles className="h-4 w-4 text-white" /></span>
                        <div><p className="text-sm font-600 leading-tight">Single Social Club</p><p className="text-[11px] text-zinc-500">Admin Console</p></div>
                    </div>
                    <nav className="flex flex-col gap-0.5 p-3">
                        {NAV.map((n) => (
                            <NavLink key={n.to} to={n.to} end={n.end} onClick={() => setOpen(false)} data-testid={`admin-nav-${n.label.toLowerCase().replace(/ /g, "-")}`}
                                className={({ isActive }) => `flex items-center gap-3 rounded px-3 py-2 text-sm font-500 ${isActive ? "bg-zinc-900 text-white" : "text-zinc-600 hover:bg-zinc-100"}`}>
                                <n.icon className="h-4 w-4" /> {n.label}
                            </NavLink>
                        ))}
                    </nav>
                    <button onClick={logout} data-testid="admin-logout" className="absolute bottom-4 left-3 flex items-center gap-2 rounded px-3 py-2 text-sm text-zinc-600 hover:bg-zinc-100"><LogOut className="h-4 w-4" /> Sign out</button>
                </aside>
                <div className="min-h-screen w-full min-w-0 flex-1 lg:ml-60">
                    <header className="sticky top-0 z-20 flex items-center gap-3 border-b border-zinc-200 bg-white px-5 py-3 lg:hidden">
                        <button onClick={() => setOpen(!open)}><Menu className="h-5 w-5" /></button>
                        <span className="text-sm font-600">Admin Console</span>
                    </header>
                    <main className="p-5 lg:p-8"><Outlet /></main>
                </div>
            </div>
        </div>
    );
}

export function AdminHeader({ title, subtitle }) {
    return (
        <div className="mb-6">
            <h1 className="text-2xl font-600 tracking-tight">{title}</h1>
            {subtitle && <p className="mt-1 text-sm text-zinc-500">{subtitle}</p>}
        </div>
    );
}

export function Badge({ children, tone = "gray" }) {
    const tones = {
        gray: "bg-zinc-100 text-zinc-700", green: "bg-emerald-100 text-emerald-700",
        amber: "bg-amber-100 text-amber-700", red: "bg-red-100 text-red-700", blue: "bg-blue-100 text-blue-700",
    };
    return <span className={`inline-block rounded px-2 py-0.5 text-xs font-600 ${tones[tone]}`}>{children}</span>;
}
